// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "content-2vqca";
var _4 = "header-1CRDj";
var _5 = "message-13X9p";
var _6 = "form-bEpSE";
var _7 = "inputWrp-3DV7h";
var _8 = "submit-3Eo4Y";
export { _1 as "__esModule", _2 as "mobile", _3 as "content", _4 as "header", _5 as "message", _6 as "form", _7 as "inputWrp", _8 as "submit" }
export default { "__esModule": _1, "mobile": _2, "content": _3, "header": _4, "message": _5, "form": _6, "inputWrp": _7, "submit": _8 }
